import { render, staticRenderFns } from "./ReassignTeam.vue?vue&type=template&id=59c15131&scoped=true"
import script from "./ReassignTeam.vue?vue&type=script&lang=js"
export * from "./ReassignTeam.vue?vue&type=script&lang=js"
import style0 from "./ReassignTeam.vue?vue&type=style&index=0&id=59c15131&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c15131",
  null
  
)

export default component.exports